import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, enumToStringConverter, moneyFormat } from "../../../../../helpers/appHelpers";

export const RateTaxRuleColumns: GridColDef[] = [
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? params.value.name : "--",
	},
	{
		field: "minTaxableAmount",
		headerName: "Min Taxable Amount",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.row.minTaxableAmount;
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(amount);
		},
	},
	{
		field: "maxTaxableAmount",
		headerName: "Max Taxable Amount",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.row.maxTaxableAmount;
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(amount);
		},
	},
	{
		field: "rateComponent",
		headerName: "Rate Component",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => (Number(params.value) * 100).toFixed(2) + "%",
	},
	{
		field: "fixedComponent",
		headerName: "Fixed Component",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(params.value);
		},
	},
	{
		field: "incomePeriod",
		headerName: "Income Period",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => enumToStringConverter(params.value),
	},
	{
		field: "onDirectIncome",
		headerName: "On Direct Income",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},

	...createdAtmodifiedAtActions,
];

export const BenefitsTaxRuleColumns: GridColDef[] = [
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? params.value.name : "--",
	},
	{
		field: "benefitTypeInstance",
		headerName: "Benefit Type",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? params.value.name : "--",
	},
	{
		field: "minTaxableAmount",
		headerName: "Min Taxable Amount",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.row.minTaxableAmount;
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(amount);
		},
	},
	{
		field: "maxTaxableAmount",
		headerName: "Max Taxable Amount",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const amount = params.row.maxTaxableAmount;
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(amount);
		},
	},
	{
		field: "rateComponent",
		headerName: "Rate Component",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => (Number(params.value) * 100).toFixed(2) + "%",
	},
	{
		field: "fixedComponent",
		headerName: "Fixed Component",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(params.value);
		},
	},
	{
		field: "isFinalTax",
		headerName: "Final Tax",
		minWidth: 150,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},

	...createdAtmodifiedAtActions,
];

export const ReliefTaxRuleColumns: GridColDef[] = [
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? params.value.name : "--",
	},
	{
		field: "taxReliefType",
		headerName: "Tax Relief Type",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? params.value.name : "--",
	},
	{
		field: "rateComponent",
		headerName: "Rate Component",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => (Number(params.value) * 100).toFixed(2) + "%",
	},
	{
		field: "fixedComponent",
		headerName: "Fixed Component",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter(params) {
			const currency = params.row.country?.currency;
			return currency?.code + " " + moneyFormat(params.value);
		},
	},
	{
		field: "incomePeriod",
		headerName: "Income Period",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => enumToStringConverter(params.value),
	},
	{
		field: "amountDerivedFrom",
		headerName: "Amount Derived From",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => enumToStringConverter(params.value) || "--",
	},

	...createdAtmodifiedAtActions,
];
